<template>
  <BaseLayout
    :mainUrl="mainUrl"
    :tableSearchUrl="searchUrl"
    :searchPlaceholder="placeHolderText"
    @child-data-state-mount="handle_external_mount"
  >
    <template v-slot:table-heading>
      <th
        width="10%"
        class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
      >
        #s/n
      </th>
      <th
        width="25%"
        class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
      >
        Patient Name
      </th>
      <th
        width="10%"
        class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
      >
        OPD/IPD
      </th>
      <th
        width="15%"
        class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
      >
        Ticket Number
      </th>
      <!-- <th
              class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
            >
              Gender
            </th> -->

      <th width="40%" class="text-secondary opacity-7"></th>
    </template>

    <template v-slot:table-contents-place>
      <tr v-for="user in users" :key="user.id">
        <td>#{{ user.id }}</td>
        <td>
          <div class="d-flex px-2 py-1">
            <div></div>
            <div class="d-flex flex-column justify-content-center">
              <h6 class="mb-0 text-sm">{{ user.name }}</h6>
              <p class="text-xs text-secondary mb-0">
                {{ user.email == null ? "--" : user.email }}
              </p>
            </div>
          </div>
        </td>
        <td>
          <p class="text-xs font-weight-bold mb-0">
            OPD/{{ user.opd == null ? "--" : user.opd }}
          </p>
          <p class="text-xs text-secondary mb-0">
            IPD/{{ user.ipd == null ? "--" : user.ipd }}
          </p>
        </td>
        <td class="align-middle text-center text-sm">
          <soft-badge color="success" variant="gradient" size="sm">{{
            user.ticket_id
          }}</soft-badge>
        </td>
        <!-- <td class="align-middle text-center">
                <span class="text-secondary text-xs font-weight-bold">{{
                  user.gender == null
                    ? "--"
                    : user.gender == 1
                    ? "Male"
                    : user.gender == 2
                    ? "Female"
                    : "Other"
                }}</span>
              </td> -->
        <td class="align-middle">
          <button
            @click="showPatientBiodata(user.patient_id)"
            class="btn btn-sm btn-primary"
          >
            <i style="font-size: 1.3em" class="fa fa-eye"></i> . View Patient</button
          >.
          <a
            class="btn btn-sm btn-secondary"
            :href="'/consultation_at_nursing/' + user.id"
            >View Services</a
          >
        </td>
      </tr>
    </template>
  </BaseLayout>
  <PatientDetails
    v-if="showPatientBio"
    @close="closePatientBio"
    :patient_id="current_patient_id"
  />
</template>

<script>
// import { generalApiRequest } from "../../api/apiIndex.js";
// import Pagination from '../components/pagination.vue';
import BaseLayout from "../../Patients/components/table_page_layout.vue";
import PatientDetails from "../../Patients/components/patient_details.vue";
//import axios from "axios";

export default {
  name: "patientsindex",
  data() {
    return {
      users: [],
      showPatientBio: false,
      current_patient_id: "",
      // visit_id: this.$route.params.storeLocation,
      allData: {},
      apiLoading: false,
      tableLoading: true,
      placeHolderText: "Search name,phone,email,opd/ipd",
      searchUrl: "search_fetch_gp_queue/Nursing",
      mainUrl: "get_all_gp_nursing_queue",
    };
  },
  components: {
    BaseLayout,
    PatientDetails,
  },

  methods: {
    handle_external_mount(payload) {
      this.users = payload;
      console.log(this.users);
    },
    showPatientBiodata(id) {
      this.current_patient_id = id;
      this.showPatientBio = true;
    },
    closePatientBio() {
      this.current_patient_id = "";
      this.showPatientBio = false;
    },
  },

  mounted() {
    // this.callApi();
  },
};
</script>

<style scoped>
/* other */
.table-container {
  width: 100%;
}

.table {
  width: 100%;
  table-layout: fixed; /* Ensures the table width doesn't exceed the container */
}

.table th,
.table td {
  word-wrap: break-word; /* Allows text to wrap onto the next line */
  white-space: normal; /* Default behavior allows text to wrap */
  font-size: 0.8em;
  color: black;
  /* padding: 0; */
  margin: 0;
}
</style>
